import {AccountDisplayStatus, AccountSearchCriteria, AccountsSortField, AccountState} from 'web-angular-client';

export class AccountSearchCriteriaImpl implements AccountSearchCriteria
{

    accountNumber?: string;
    accountsSortField?: AccountsSortField;
    amountLower?: number;
    amountUpper?: number;
    customer?: string;
    dateTimeCreatedLower?: string;
    dateTimeCreatedUpper?: string;
    dateTimePaidLower?: string;
    dateTimePaidUpper?: string;
    displayStatus?: AccountDisplayStatus;
    ecommerceStoreIds?: number[];
    businessECommerceStoreIds?: number[];
    referenceNumber?: string;
    status?: Array<AccountState>;
    individualAccountsOnly: boolean;
    batchNumber?: number;

    constructor()
    {
        this.accountNumber = null;
        this.accountsSortField = null;
        this.amountLower = null;
        this.amountUpper = null;
        this.customer = null;
        this.dateTimeCreatedLower = null;
        this.dateTimeCreatedUpper = null;
        this.dateTimePaidLower = null;
        this.dateTimePaidUpper = null;
        this.displayStatus = AccountDisplayStatus.ANY;
        this.ecommerceStoreIds = null;
        this.businessECommerceStoreIds = null;
        this.referenceNumber = null;
        this.status = [];
        this.individualAccountsOnly = true;
        this.batchNumber = null;
    }
}